import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ITableDriftSummaryDto } from '../../../../models/features/schema-drift/ITableDriftSummaryDto';
import { HeaderService } from '../../../../services/_app/header/header.service';
import { SchemaDriftService } from '../../../../services/_app/schema-drift/schema-drift.service';
import { AuditProfileService } from '../../../../services/audit-profile/audit-profile.service';
import { BaseComponent } from '../../../base/base.component';

@Component({
  selector: 'app-schema-drift-summary',
  templateUrl: './schema-drift-summary.component.html',
  styleUrls: ['./schema-drift-summary.component.css']
})
export class SchemaDriftSummaryComponent extends BaseComponent implements OnInit, AfterViewInit {
  // *********************
  // variables declaration
  // *********************

  // private
  // ********

  // public
  // ******
  @Input() driftData: any;

  public databaseName: string = '...';
  public skeleton: boolean = true;
  public sortedColumn: keyof ITableDriftSummaryDto | '' = '';
  public sortAscending: boolean = true;
  public isGridShow: boolean = true;
  public all: boolean = false;
  public isPreviewDataSelected: boolean = false;

  constructor(private auditProfileService: AuditProfileService,
    private headerService: HeaderService,
    private schemaDriftService: SchemaDriftService,
    private router: Router) {
    super();
  }

  // ***************
  // lifecycle hooks
  // ***************
  override async ngOnInit() {
    await this.housekeeping();
  }

  ngAfterViewInit(): void {
  }

  // *******
  // methods
  // *******

  // public
  // ******
  public showTableData(tableName: ITableDriftSummaryDto) {
    //this.PreviewDataTableSchema = record.tableSchema;
    //this.PreviewDataTableName = record.tableName;
    this.isPreviewDataSelected = true;
    // get from LighthouseDashboardComponent
  }

  public sortByColumn(columnName: keyof ITableDriftSummaryDto): void {
    debugger;
    const isSameColumn = this.sortedColumn === columnName;
    this.sortAscending = isSameColumn ? !this.sortAscending : true;
    this.sortedColumn = columnName;

    const getComparableValue = (row: ITableDriftSummaryDto): number | string => {
      const value = row[columnName] as any;

      if (columnName === 'lastChangeDate') {
        if (!value) return 0;

        const time = value instanceof Date ? value.getTime() : new Date(value).getTime();

        return isNaN(time) ? 0 : time;
      }

      return value ?? '';
    };

    this.driftData.FilteredTableDriftSummary.sort((a:any, b:any) => {
      const av = getComparableValue(a);
      const bv = getComparableValue(b);

      if (typeof av === 'number' && typeof bv === 'number') {
        const result = av - bv;

        return this.sortAscending ? result : -result;
      }

      const result = String(av).localeCompare(String(bv), undefined, { numeric: true, sensitivity: 'base' });

      return this.sortAscending ? result : -result;
    });
  }

  public close(event: boolean) {
    this.isPreviewDataSelected = false;
  }

  // private
  // *******
  private async housekeeping() {
    this.skeleton = false;
  }

}

